import {Component, OnDestroy, OnInit, input} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import * as fromProfile from '../store/profile.reducers';
import * as fromPost from './../post/store/post.reducers';
import * as fromApp from '../../store/app.reducers';
import * as PostActions from '../post/store/post.actions';
import {ProfileService} from '../profile.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-profile-media',
    templateUrl: './profile-media.component.html',
    styleUrls: ['./profile-media.component.scss'],
    standalone: false
})
export class ProfileMediaComponent implements OnInit, OnDestroy {

  readonly type = input<number>(undefined);
  id: number;
  profileState: Observable<fromProfile.State>;
  postState: Observable<fromPost.State>;
  routeSubscription: Subscription;
  hasLimit: boolean;
  hasLimitSubscription: Subscription;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private notifierService: ToastrService,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
    this.postState = this.store.select('post');
    this.hasLimitSubscription = this.profileService.hasActivePostLimit().subscribe(
      (hasLimit: boolean) => {
        this.hasLimit = hasLimit;
      }
    );
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        this.id = params.id;
        if (+this.type() === 1) {

        } else if (+this.type() === 2) {
          this.store.dispatch(
            new PostActions.GetProfileMedia({id: this.id})
          );
        }
      }
    );
  }

  addPostAudit(post: string) {
    if (this.hasLimit) {
      this.store.dispatch(
        new PostActions.AddAudit(post)
      );
    } else {
      this.notifierService.warning('You have no credits');
    }
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.hasLimitSubscription.unsubscribe();
  }

}
